import * as React from "react";
import type { SVGProps } from "react";
const SvgPlans = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      fill="#90B9FF"
      d="M3.989 1C3.009 1.003 2 1.612 2 2.816v7.127c0 .963.807 1.751 1.795 1.751H5.42a.38.38 0 0 0 .383-.373V2.609C5.802 1.529 4.91.997 3.99 1"
      opacity={0.8}
    />
    <path
      fill="#23F6E7"
      d="M21.114 1.342H6.64a.15.15 0 0 0-.147.108.146.146 0 0 0 .066.168c.536.326.895.905.895 1.563v17.944A.89.89 0 0 0 8.35 22h13.752a.89.89 0 0 0 .897-.875V3.18c0-1.012-.849-1.84-1.886-1.84"
    />
  </svg>
);
export default SvgPlans;
